import { Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import { UserService } from '../../../services/user.service';
import { ChatService } from '../../../services/chat.service';
import { TranslateService } from '@ngx-translate/core';
import { NotificacionesService } from 'src/app/services/notificaciones.service';

@Component({
  selector: 'app-userbox-chat',
  templateUrl: './userbox-chat.component.html',
  styleUrls: ['./userbox-chat.component.css']
})
export class UserboxChatComponent implements OnChanges {
  @Input() mainUserId;
  @Input() members;
  @Input() chatUsers;
  @Input() chatGroups;
  @Input() activity;
  @Input() activeChats;
  @Input() firstName;
  @Input() lastName;

  presence: any;
  disconnectedTime: any;
  chats: any;
  showDeletePopup : boolean = false;
  totalNotifications: number = 0;

  constructor(private userService: UserService,
              private chatService: ChatService,
              private notificationsService: NotificacionesService,
              private translate : TranslateService) { }

  ngOnChanges(changes: SimpleChanges) {
    const members = changes.members?.currentValue ?? this.members;
    const mainUserId = changes.mainUserId?.currentValue ?? this.mainUserId;
    this.chats = changes.activeChats?.currentValue ?? this.activeChats;

    if (!members || !mainUserId) return;

    const uid = members[1].uid === mainUserId ? members[0].uid : members[1].uid;

    this.notificationsService.getNotificacionesMensajesDeEmisor(mainUserId,uid).subscribe(messages=>{
      this.totalNotifications = 0;
      if(messages.length>0){
       this.totalNotifications= messages.length
     }
    })
    this.getUserPresence(uid);

  }

  get chatUser(){
    if (!this.members || !this.mainUserId) {
      return null;
    }

    const otherUserId =
      this.members[1]?.uid === this.mainUserId
        ? this.members[0]?.uid
        : this.members[1]?.uid;

    return this.chatUsers?.[otherUserId];
  }

  get chatUserName(){
    return this.chatUser?.name || this.chatUser?.nombres || this.chatUser?.firstName || this.chatUser?.display_name || '';
  }

  get chatUserLastName(){
    return this.chatUser?.last_name || this.chatUser?.apellidos || this.chatUser?.apellido || this.chatUser?.lastName || '';
  }

  get chatUserFullName(){
    return `${this.chatUserName} ${this.chatUserLastName}`.trim() || this.chatUserUsername || this.formatFallbackUser(this.otherUserId);
  }

  get mainUserFirstName(){
    return this.firstName;
  }

  get mainUserLastName(){
    return this.lastName;
  }

  get chatUserUsername(){
    return this.chatUser?.username || this.chatUser?.usuario || this.chatUser?.email || this.chatUser?.uid || '';
  }

  get otherUserId() {
    if (!this.members || !this.mainUserId) {
      return '';
    }

    return this.members[1]?.uid === this.mainUserId
      ? this.members[0]?.uid
      : this.members[1]?.uid;
  }

  formatFallbackUser(userId: string): string {
    return userId ? `Usuario ${userId.slice(0, 8)}` : '';
  }

  get chatUrl(){
    return  [this.mainUserId, this.otherUserId].sort().join('|');
  }

  get lastChatMessage(){
    return  this.chatGroups[[this.members[0]?.uid, this.members[1]?.uid].sort().join('|')];
  }



  getUserPresence(uid) {
    if (uid) {

      this.userService.getPresence(uid).subscribe(presence => {
        if (presence != null) {
          this.presence = presence;
          this.disconnectedTime = this.timeDifference(Math.floor(new Date().getTime()/1000.0), this.presence.timestamp );
          this.presence = this.presence.status;
        }
      });

    }
  }

  timeDifference(date1, date2) {
    if(date1 > Math.floor(date2/1000.0)) {
      var difference =  date1 - Math.floor(date2/1000.0);
    } else  {
      var difference =  Math.floor(date2/1000.0) - date1;
    }

    var seconds = Number(difference);
    var d = Math.floor(seconds / (3600*24));
    var h = Math.floor(seconds % (3600*24) / 3600);
    var m = Math.floor(seconds % 3600 / 60);
    var s = Math.floor(seconds % 60);

    let len = this.translate.getDefaultLang();
    var dDisplay = "";
    var hDisplay = "";
    var mDisplay = "";
    var sDisplay = "";

    switch (len) {
      case "en":
        dDisplay = d > 0 ? d + (d == 1 ? " day " : " days ") : "";
        hDisplay = h > 0 ? h + (h == 1 ? " hour " : " hours ") : "";
        mDisplay = m > 0 ? m + (m == 1 ? " minute " : " minutes ") : "";
        sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
        break;
      case "es":
          var dDisplay = d > 0 ? d + (d == 1 ? " día " : " días ") : "";
          var hDisplay = h > 0 ? h + (h == 1 ? " hora " : " horas ") : "";
          var mDisplay = m > 0 ? m + (m == 1 ? " minuto " : " minutos ") : "";
          var sDisplay = s > 0 ? s + (s == 1 ? " segundo" : " segundos") : "";
        break;
        case "ar":
          var dDisplay = d > 0 ? d + (d == 1 ? "  يوم " : " أيام ") : "";
          var hDisplay = h > 0 ? h + (h == 1 ? " ساعة " : "  ساعات ") : "";
          var mDisplay = m > 0 ? m + (m == 1 ? " دقيقة " : " دقائق ") : "";
          var sDisplay = s > 0 ? s + (s == 1 ? "  ثانية" : " ثواني") : "";
        break;
      default:
        break;
    }
  


    // var dDisplay = d > 0 ? d + (d == 1 ? " día " : " días ") : "";
    // var hDisplay = h > 0 ? h + (h == 1 ? " hora " : " horas ") : "";
    // var mDisplay = m > 0 ? m + (m == 1 ? " minuto " : " minutos ") : "";
    // var sDisplay = s > 0 ? s + (s == 1 ? " segundo" : " segundos") : "";

    var content = '';

    if (s > 0) {
      content = sDisplay;
    }
    if (m > 0) {
      content = mDisplay;
    }
    if (h > 0) {
      content = hDisplay;
    }
    if (d > 0) {
      content = dDisplay;
    }

    return content;
  }

  deleteChat(mainUserId, chatUser){
    const data = {
      mainUserId, userId: chatUser
    };
    this.chatService.borrarelChat(data);
  }
  toggleDeletePopup(){
    this.showDeletePopup? this.showDeletePopup = false : this.showDeletePopup = true;
  }


}
